import { ReactComponent as SvgChevronLeft } from '@img/icons/chevron-left.svg';
import React from 'react';
import S from '../List/FilterList.styles';
import Checkbox from '@stories/Components/Inputs/Checkbox/Checkbox';
const FilterList = ({ selectedFilters, selectedValues, title, onApply, onCancel, onClear, onRemove, onFilterChange, }) => {
    function updateFilters(key, value, e) {
        e.stopPropagation();
        if (selectedFilters && onFilterChange) {
            const tempValues = selectedValues;
            if (tempValues && !tempValues.includes(value)) {
                tempValues.push(value);
                onFilterChange(key, tempValues);
            }
            else {
                if (tempValues) {
                    const newList = tempValues.filter((prof) => prof !== value);
                    onFilterChange(key, newList);
                }
            }
        }
    }
    return (React.createElement(S.ItemList, null,
        React.createElement(S.Title, { disabled: !onCancel, onClick: (event) => {
                event.preventDefault();
                onCancel && onCancel();
            } },
            onCancel && React.createElement(SvgChevronLeft, null),
            title),
        React.createElement(S.CheckboxArea, null, selectedFilters &&
            selectedFilters.options?.map((item) => (React.createElement(Checkbox, { key: item.id, type: "checkbox", checked: selectedValues?.includes(item.value), id: item.id, name: item.text, value: item.value, labelText: item.text, onChange: (event) => updateFilters(selectedFilters.key, event.target.value, event) })))),
        onApply && (React.createElement(S.FilterBtns, null,
            React.createElement(S.BtnHolder, null,
                React.createElement(S.ApplyFilters, { title: "Apply Filters", themeOption: "rssGreen", onClick: (event) => {
                        event.preventDefault();
                        onApply && onApply();
                    } })),
            React.createElement(S.BtnHolder, null,
                React.createElement(S.RemoveFilters, { title: "Remove Filters", themeOption: "rssWhiteOutline", onClick: (event) => {
                        event.preventDefault();
                        onRemove && onRemove();
                    } })))),
        onClear && (React.createElement(S.Clear, { onClick: (event) => {
                event.preventDefault();
                onClear();
            } }, "Clear"))));
};
export default FilterList;
